import { PageConfig } from "../../types/types";
import { componentMap, StandardProps } from "../../components/componentMap";
import { ErrorBoundary } from "../../utils/error/ErrorBoundary";

type SlotProps = {
  name: string;
  pageConfig: PageConfig;
  className?: string;
  sizes: string;
} & StandardProps;

export function Slot({
  name,
  className = "",
  sizes,
  pageConfig,
  ...standardProps
}: SlotProps) {
  const components = pageConfig.slots[name];

  if (!components || components.length < 1) {
    return null;
  }

  return (
    <div className={className} data-slot={name} data-testid="slot">
      {components?.map((componentConfig, index) => {
        const Component = componentMap[componentConfig.name];
        const componentKey = `${componentConfig.name}-${index}`;

        return Component ? (
          <ErrorBoundary
            componentName={componentConfig.name}
            key={componentKey}
          >
            <Component
              {...standardProps}
              configProps={componentConfig.props}
              sizes={sizes}
            />
          </ErrorBoundary>
        ) : null;
      })}
    </div>
  );
}
